import "../../App.css";
import {
  Catalogo,
  Categorias,
  Footer,
  Header,
  Home,
  Login,
  Pedidos,
  Register,
  SideNav,
  Usuarios,
  Ventas,
  Replenish,
  EditProduct,
  EditCategories,
  CreatePayment,
  CreateAdvertisement,
  EditAdvertisement,
  Recover,
  Redimir,
  CreateBank,
  Cuentas,
  EditBank,
  ChangePass,
  Checkout,
  PointsHistory,
  Dashboard,
  WhatsappConfig,
  DeliveryOrders,
  DeliveryEarnings,
  DeliveryMap,
  DeliveryPayouts,
  ConfigPanel,
} from "../pages";
import { Route, Routes } from "react-router-dom";
import Protected from "./Protected";
import { MobileNav } from "../pages/MobileNav";
import { CreateProduct } from "../pages/CreateProducts";
import { CreateCategories } from "./../pages/CreateCategories";
import { CartProvider } from "../../context/cart";
import { CanjeProvider } from "../../context/canje";
import { PointProvider } from "../../context/point";
import { NotificationsListener } from "../pages/NotificationsListener";

export const AppRouter = () => {
  return (
    <PointProvider>
      <CanjeProvider>
        <CartProvider>
          <NotificationsListener />
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/" element={<Protected />}>
              <Route path="/usuarios" element={<Usuarios />} />
              <Route path="/ventas" element={<Ventas />} />
              <Route path="/producto" element={<CreateProduct />} />
              <Route path="/editar-producto" element={<EditProduct />} />
              <Route path="/editar-categoria" element={<EditCategories />} />
              <Route path="/categorias" element={<Categorias />} />
              <Route path="/categoria" element={<CreateCategories />} />
              <Route path="/pago" element={<CreatePayment />} />
              <Route
                path="/crear-anuncio"
                element={<CreateAdvertisement />}
              />
              <Route path="/editar-anuncio" element={<EditAdvertisement />} />
              <Route path="/cuentas" element={<Cuentas />} />
              <Route path="/crear-cuenta" element={<CreateBank />} />
              <Route path="/editar-cuenta" element={<EditBank />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/mis-puntos" element={<PointsHistory />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/whatsapp" element={<WhatsappConfig />} />
              <Route path="/configuracion" element={<ConfigPanel />} />
              <Route path="/domicilios" element={<DeliveryOrders />} />
              <Route path="/domicilios/mapa/:purchaseId" element={<DeliveryMap />} />
              <Route path="/domicilios/ganancias" element={<DeliveryEarnings />} />
              <Route path="/domicilios/pagos" element={<DeliveryPayouts />} />
              <Route
                path="/reposicion/:productId/:pCost/:pStock/:pName"
                element={<Replenish />}
              />
            </Route>
            <Route path="/catalogo" element={<Catalogo />} />
            <Route path="/pedidos" element={<Pedidos />} />
            <Route path="/registro" element={<Register />} />
            <Route path="/ingreso" element={<Login />} />
            <Route path="/recuperar" element={<Recover />} />
            <Route path="/canjear" element={<Redimir />} />
            <Route path="/actualizar-celular" element={<ChangePass />} />
          </Routes>
          <SideNav />
          <MobileNav />
          <Footer />
        </CartProvider>
      </CanjeProvider>
    </PointProvider>
  );
};
